/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { PortalsManagerTypes, PortalsManagerState } from './types';

const INITIAL_STATE: PortalsManagerState = {
  portals_manager: [],
  request: {
    save_portal: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_portals: {
      loading: false,
      loaded: false,
      error: false,
    },
    delete_portal: {
      loading: false,
      loaded: false,
      error: false,
    },
    update_portal: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};
const reducer: Reducer<PortalsManagerState> = (state = INITIAL_STATE, { type, result }) => {
  return produce(state, (draft) => {
    switch (type) {
      case PortalsManagerTypes.SAVE_PORTAL_REQUEST:
        draft.request.save_portal = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case PortalsManagerTypes.SAVE_PORTAL_SUCCESS:
        draft.request.save_portal = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case PortalsManagerTypes.SAVE_PORTAL_FAILURE:
        draft.request.save_portal = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;

      case PortalsManagerTypes.GET_PORTLS_REQUEST:
        draft.portals_manager = INITIAL_STATE.portals_manager;
        draft.request.get_portals = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case PortalsManagerTypes.GET_PORTLS_SUCCESS:
        draft.portals_manager = result?.data?.portals;
        draft.request.get_portals = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case PortalsManagerTypes.GET_PORTLS_FAILURE:
        draft.portals_manager = INITIAL_STATE.portals_manager;
        draft.request.get_portals = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case PortalsManagerTypes.DELETE_PORTAL_REQUEST:
        draft.request.delete_portal = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case PortalsManagerTypes.DELETE_PORTAL_SUCCESS:
        draft.request.delete_portal = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case PortalsManagerTypes.DELETE_PORTAL_FAILURE:
        draft.request.delete_portal = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case PortalsManagerTypes.UPDATE_PORTAL_REQUEST:
        draft.request.update_portal = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case PortalsManagerTypes.UPDATE_PORTAL_SUCCESS:
        draft.request.update_portal = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case PortalsManagerTypes.UPDATE_PORTAL_FAILURE:
        draft.request.update_portal = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      default:
    }
  });
};
export default reducer;
